import { createFileRoute, Link, Outlet, redirect } from '@tanstack/react-router'
import { Button } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useCampaign } from '../campaign/hooks'
import { NetworkErrors } from '../components/network-errors'
import { z } from 'zod'
import { SHOW_CAMPAIGN } from '../user/permission'

export const Route = createFileRoute('/_auth/_main/campaigns/$campaignId')({
    beforeLoad: ({ context }) => {
        if (!context.auth.can(SHOW_CAMPAIGN)) {
            throw redirect({
                to: '/dashboard',
            })
        }
    },
    component: ShowCampaign,
    validateSearch: z.object({
        bulk: z.boolean().optional(),
    }),
})

function ShowCampaign() {
    const { t } = useTranslation()
    const { campaignId } = Route.useParams()

    const campaign = useCampaign(campaignId)

    if (campaign.isPending || campaign.isError) {
        return (
            <NetworkErrors
                query={campaign}
                result404={{
                    title: t('Campaign not found'),
                    extra: (
                        <Link to="/campaigns">
                            <Button type="primary">{t('Campaigns')}</Button>
                        </Link>
                    ),
                }}
            />
        )
    }

    return <Outlet />
}
